import { Chip } from "@mui/material";
import type { NotificationFilters } from "@services/notifications/list/type";
import { NOTIFICATION_FILTER_OPTIONS } from "@utils/translator/notifications";

type NotificationFilterProps = {
  filters: NotificationFilters;
  onChange: (field: keyof NotificationFilters, value: string) => void;
  onApply: () => void;
};

function NotificationFilter({ filters, onChange }: NotificationFilterProps) {
  const handleChipClick = (value: string) => {
    onChange("type", value);
  };

  return (
    <div className="flex flex-wrap gap-2 justify-start">
      {NOTIFICATION_FILTER_OPTIONS.map((option) => (
        <Chip
          key={option.value}
          label={option.label}
          onClick={() => handleChipClick(option.value)}
          sx={{
            backgroundColor:
              (filters.type || "") === option.value ? "#32bc9b" : "#e5e7eb",
            color:
              (filters.type || "") === option.value ? "#ffffff" : "#1f2937",
            "&:hover": {
              backgroundColor:
                (filters.type || "") === option.value ? "#2aa388" : "#d1d5db",
            },
            cursor: "pointer",
            transition: "all 0.2s",
            height: "36px",
            fontSize: "0.9375rem",
            "& .MuiChip-label": {
              padding: "0 16px",
            },
          }}
        />
      ))}
    </div>
  );
}

export default NotificationFilter;
